import React, { Component, createRef } from 'react';
import { Link } from "react-router-dom";
import filtersStore from '../../stores/filtersStore';
import history from '../common/history.js';
import DemoPlayButton from '../common/DemoPlayButton';

class PopularPack extends Component {
  constructor(props) {
    super(props)
    this.demoPlayBtnRef = createRef(null)
    this.labelBtnRef = createRef(null)
  }

  redirectToPack = (e) => {
    if(!this.isActionButton(e)) {
      e.preventDefault();
      filtersStore.reset();
      filtersStore.toParams();
      const { id, seo_product_id } = this.props.pack
      history.push(`/product/${seo_product_id || id}`);
    }
  }

  isActionButton = (e) => {
    return this.demoPlayBtnRef.current == e.target ||
      this.demoPlayBtnRef.current.contains(e.target) ||
      this.labelBtnRef.current == e.target ||
      this.labelBtnRef.current.contains(e.target)
  }

  render() {
    const { seo_label_id, label_id } = this.props.pack

    return (
      <div
        className='flex cursor-pointer items-center font-bold border-b first-of-type:border-t border-gray-11 group hover:bg-gray-15'
        onClick={this.redirectToPack}
      >
        <div className='h-fit self-start pl-1.5 py-2.5 min-w-[26px] max-w-[26px] text-sm'>
          <span>{this.props.number + 1}</span>
        </div>
        <div className='flex relative min-w-[60px] min-h-[60px]' ref={this.demoPlayBtnRef}>
          <img src={this.props.pack.cover_small} className='w-full' />
          <DemoPlayButton product={this.props.pack} />
        </div>
        <div className='flex flex-col justify-between h-full p-2.5'>
          <p className='text-[15px] line-clamp-1'>{this.props.pack.title}</p>
          <Link to={"/label/" + (seo_label_id || label_id)} ref={this.labelBtnRef}>
            <p className='text-[11px] text-gray-3'>{this.props.pack.label_name}</p>
          </Link>
        </div>
      </div>
    )
  }
}

export default PopularPack;
